/**
 * Fallbacks for the `ProgramState` labels the backend can leave empty. Shared by the overlays and by
 * `swimlaneItemAriaLabel`, so the visible text and the screen reader announcement cannot drift apart.
 */
export const programStateFallbackLabel = {
  live: 'Direkte',
  noAccess: 'Du har ikke tilgang til denne tilbyderen',
  expired: 'IKKE TILGJENGELIG I ARKIVET',
  planned: 'Sendes senere',
} as const;
